import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";

const getInitial = () => {
  try {
    const saved = localStorage.getItem("amaya_theme");
    if (saved) return saved;
  } catch (e) {}
  return "dark";
};

export default function ThemeToggle({ className = "" }) {
  const [theme, setTheme] = useState(getInitial);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    try {
      localStorage.setItem("amaya_theme", theme);
    } catch (e) {}
  }, [theme]);

  const isDark = theme === "dark";
  return (
    <button
      onClick={() => setTheme(isDark ? "light" : "dark")}
      aria-label={isDark ? "Switch to light theme" : "Switch to dark theme"}
      aria-pressed={isDark}
      data-testid="theme-toggle-btn"
      className={`p-2 border transition-colors ${
        isDark
          ? "border-[#333333] text-leaf hover:border-signal"
          : "border-zinc-300 text-ink hover:border-signal"
      } ${className}`}
    >
      <span className="block transition-transform duration-500" style={{ transform: isDark ? "rotate(180deg)" : "rotate(0deg)" }}>
        {isDark ? <Sun size={16} /> : <Moon size={16} />}
      </span>
    </button>
  );
}
